import { IUserAccountStore } from '../../index'

export default function(store: IUserAccountStore) {
  return {
    ...store,
    notifications: {
      ...store.notifications,
      seen: true,
    },
  }
}
